import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {SearchRequestModel} from '../../../shared/dto/search-request.model';
import {RequestSearchComponent} from '../request-search.component';
import {SearchRequestService} from '../../../shared/service/search-request.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-request-search-table',
  templateUrl: './request-search-table.component.html',
  styleUrls: ['./request-search-table.component.scss']
})
export class RequestSearchTableComponent implements OnInit ,AfterViewInit{
  @Input() items: SearchRequestModel[] = [];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  public item : SearchRequestModel[] = [];
  displayedColumns: string[] = ['requestId', 'applicantType', 'name', 'cdcNo' ,'cocNo','date','status', 'action'];
  dataSource: MatTableDataSource<any>;


  constructor(private requsetSearchComponent: RequestSearchComponent,
              private requestSearchService: SearchRequestService,
              public modalService: NgbModal,
              private router: Router,
              private route: ActivatedRoute,
              private searcRequestService:SearchRequestService) { }

  ngOnInit() {
   this.loadData();
  }

  loadData() {
    // console.log(this.items);
    this.searcRequestService.getAllRequests().subscribe(
      (data: SearchRequestModel[]) => {
        this.item = data;
        this.dataSource = new MatTableDataSource(this.item);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}

